import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../../reducers';
import PhaseType from 'types/phase';

class CustomerPreWalkthrough extends Resetter(Validator(React.Component)) {
  state = {
    customerMaterialsAndColor: this.props.customerMaterialsAndColor || false,
    customerClimateControl: this.props.customerClimateControl || false,
    customerCarpetSeamPlacement: this.props.customerCarpetSeamPlacement || false,
    customerCarpetRoomsToBeInstalled: this.props.customerCarpetRoomsToBeInstalled || false,
    customerCarpetScuffs: this.props.customerCarpetScuffs || false,
    customerHardSurfaceRoomsAndMoisture: this.props.customerHardSurfaceRoomsAndMoisture || false,
    customerHardSurfaceMoistureBarrier: this.props.customerHardSurfaceMoistureBarrier || false,
    errors: {},
  };

  customerPreWalkthroughRef = React.createRef();

  componentDidMount = () => this.customerPreWalkthroughRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { customerMaterialsAndColor, customerClimateControl, customerCarpetSeamPlacement,
      customerCarpetRoomsToBeInstalled, customerCarpetScuffs, customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier } = this.state;
    this.props.updateFormData({
      customerMaterialsAndColor,
      customerClimateControl,
      customerCarpetSeamPlacement,
      customerCarpetRoomsToBeInstalled,
      customerCarpetScuffs,
      customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier,
      tab: 5,
    });
  }

  handlePrevious = () => {
    const { customerMaterialsAndColor, customerClimateControl, customerCarpetSeamPlacement,
      customerCarpetRoomsToBeInstalled, customerCarpetScuffs, customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier } = this.state;
    this.props.updateFormData({
      customerMaterialsAndColor,
      customerClimateControl,
      customerCarpetSeamPlacement,
      customerCarpetRoomsToBeInstalled,
      customerCarpetScuffs,
      customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier,
      tab: 2,
    });
  }

  handleCustomerMaterialsAndColor = () =>
    this.setState({ customerMaterialsAndColor: !this.state.customerMaterialsAndColor });

  handleCustomerClimateControl = () =>
    this.setState({ customerClimateControl: !this.state.customerClimateControl });

  handleCustomerCarpetSeamPlacement = () =>
    this.setState({ customerCarpetSeamPlacement: !this.state.customerCarpetSeamPlacement });

  handleCustomerCarpetRoomsToBeInstalled = () =>
    this.setState({
      customerCarpetRoomsToBeInstalled: !this.state.customerCarpetRoomsToBeInstalled,
    });

  handleCustomerCarpetScuffs = () =>
    this.setState({ customerCarpetScuffs: !this.state.customerCarpetScuffs });

  handleCustomerHardSurfaceRoomsAndMoisture = () =>
    this.setState({
      customerHardSurfaceRoomsAndMoisture: !this.state.customerHardSurfaceRoomsAndMoisture,
    });

  handleCustomerHardSurfaceMoistureBarrier = () =>
    this.setState({
      customerHardSurfaceMoistureBarrier: !this.state.customerHardSurfaceMoistureBarrier,
    });

  render = () => {
    const { isSpanish } = this.props;
    const {
      customerMaterialsAndColor,
      customerClimateControl,
      customerCarpetSeamPlacement,
      customerCarpetRoomsToBeInstalled,
      customerCarpetScuffs,
      customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier,
      errors,
    } = this.state;

    return (<div ref={this.customerPreWalkthroughRef}>
      <h6>
        {isSpanish ? 'Lista de Verificación del Cliente' : 'Customer Checklist'}
      </h6>
      <CheckBox
        required
        text={isSpanish
          ? 'He verificado materiales y color'
          : 'I have verified the materials and color'
        }
        errors={errors.customerMaterialsAndColor}
        onChange={this.handleCustomerMaterialsAndColor}
        checked={customerMaterialsAndColor}
      />
      <CheckBox
        required
        text={isSpanish
          ? 'El control climático ha estado encendido durante 72 horas'
          : 'Climate control has been on for 72 hours'
        }
        errors={errors.customerClimateControl}
        onChange={this.handleCustomerClimateControl}
        checked={customerClimateControl}
      />
      {this.props.surfaceType.toLowerCase() === 'carpet' ? (<span>
        <CheckBox
          required
          text={isSpanish
            ? 'Aprobé la colocación de la costura'
            : 'I approved the seam placement'
          }
          errors={errors.customerCarpetSeamPlacement}
          onChange={this.handleCustomerCarpetSeamPlacement}
          checked={customerCarpetSeamPlacement}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'He verificado las habitaciones a instalar'
            : 'I have verified the rooms to be installed'
          }
          errors={errors.customerCarpetRoomsToBeInstalled}
          onChange={this.handleCustomerCarpetRoomsToBeInstalled}
          checked={customerCarpetRoomsToBeInstalled}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'Entiendo que las paredes y los zócalos se pueden raspar durante la instalación estándar'
            : 'I understand the walls and baseboards can be scuffed during standard installation'
          }
          errors={errors.customerCarpetScuffs}
          onChange={this.handleCustomerCarpetScuffs}
          checked={customerCarpetScuffs}
        />
      </span>) : (<span>
        <CheckBox
          required
          text={isSpanish
            ? 'He verificado las habitaciones a instalar y las lecturas de humedad'
            : 'I have verified the rooms to be installed and moisture readings'
          }
          errors={errors.customerHardSurfaceRoomsAndMoisture}
          onChange={this.handleCustomerHardSurfaceRoomsAndMoisture}
          checked={customerHardSurfaceRoomsAndMoisture}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'El hogar tiene una barrera de humedad aprobada para gatear'
            : 'Home has an approved crawlspace moisture barrier'
          }
          errors={errors.customerHardSurfaceMoistureBarrier}
          onChange={this.handleCustomerHardSurfaceMoistureBarrier}
          checked={customerHardSurfaceMoistureBarrier}
        />
      </span>)}
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

CustomerPreWalkthrough.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  surfaceType: PropTypes.string,
  customerMaterialsAndColor: PropTypes.bool,
  customerClimateControl: PropTypes.bool,
  customerCarpetSeamPlacement: PropTypes.bool,
  customerCarpetRoomsToBeInstalled: PropTypes.bool,
  customerCarpetScuffs: PropTypes.bool,
  customerHardSurfaceRoomsAndMoisture: PropTypes.bool,
  customerHardSurfaceMoistureBarrier: PropTypes.bool,
  errors: PropTypes.shape({
    customerMaterialsAndColor: PropTypes.arrayOf(PropTypes.string),
    customerClimateControl: PropTypes.arrayOf(PropTypes.string),
    customerCarpetSeamPlacement: PropTypes.arrayOf(PropTypes.string),
    customerCarpetRoomsToBeInstalled: PropTypes.arrayOf(PropTypes.string),
    customerCarpetScuffs: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceRoomsAndMoisture: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceMoistureBarrier: PropTypes.arrayOf(PropTypes.string),
  }),
};


export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(CustomerPreWalkthrough);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/pre/customerPreWalkthrough.jsx